import { node } from "~/util/dom";

export default class SuggestOverlay {
	#input: HTMLInputElement;

	#overlay: HTMLDivElement;

	constructor(input) {
		this.#input = input;
		this.#overlay = node("div", { className: "suggest-overlay" });

		//this.#input.addEventListener("input", this, false);
		//this.#input.addEventListener("blur", this, false);
	}

	destroy() {
		//this.#input.removeEventListener("input", this, false);
		//this.#input.removeEventListener("blur", this, false);
		this.hide();
	}

	/*handleEvent(event: Event) {
		if (event.type === "input") {
			if (this.#input.value) {
				this.show();
			} else {
				this.hide();
			}
		} else if (event.type === "blur") {
			this.hide();
		}
	}*/

	show() {
		this.#input.before(this.#overlay);
		this.#input.classList.add("ignore-suggest-overlay");
	}

	hide() {
		this.#overlay.remove();
		this.#input.classList.remove("ignore-suggest-overlay");
	}
}
